// components/chat/chat-input/LexicalSendCommand.tsx
import { useEffect } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getRoot } from "lexical";

export const LexicalSendCommand: React.FC<{
  sendTrigger: number;
  onSend: (text: string) => void;
}> = ({ sendTrigger, onSend }) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (sendTrigger > 0) {
      const text = editor.getEditorState().read(() => {
        return $getRoot().getTextContent();
      });
      
      if (text.trim()) {
        onSend(text);
        // Clear editor after sending
        editor.update(() => {
          const root = $getRoot();
          root.clear();
        });
      }
    }
  }, [sendTrigger, editor, onSend]);

  return null;
};
